'use client';

import type { ForwardedRef, ReactNode } from 'react';
import { forwardRef } from '../../forward-ref.js';
import type { CommonProps } from '../types.js';

export interface TableBodyProps extends CommonProps {
  /** The rows that belong to this table body. */
  children: ReactNode;
}

function TableBody(
  { children, UNSAFE_className, UNSAFE_style, ...props }: TableBodyProps,
  ref: ForwardedRef<HTMLTableSectionElement>,
) {
  return (
    <tbody {...props} ref={ref} className={UNSAFE_className} style={UNSAFE_style}>
      {children}
    </tbody>
  );
}

/**
 * Renders a body section within a table.
 *
 * See [table usage guidelines](https://ui.cimpress.io/components/table/) and [table building guide](https://ui.cimpress.io/dev-guides/tables/).
 */
const _TableBody = forwardRef(TableBody, 'TableBody');

export { _TableBody as TableBody };
